import { jsx as _jsx } from "react/jsx-runtime";
import { LabelsItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = (props) => _jsx(LabelsItem, { isAdd: true, ...props });
export default Add;
